import { render } from "./index.vue?vue&type=template&id=43834bd5&scoped=true&bindings={}"
import script from "./MainHeading.js?vue&type=script&lang=js"
export * from "./MainHeading.js?vue&type=script&lang=js"

import "./MainHeading.scss?vue&type=style&index=0&id=43834bd5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-43834bd5"

export default script